import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { DATA_ANALYTICS, DATA_REASON, DATA_TYPE } from '../../const/analytics';
const CollapseButton = styled.div `
  cursor: pointer;
`;
const AutopayBannerCollapseButton = ({ children, isExpandable, isExpanded, toggleIsExpanded }) => {
    const dataReason = isExpanded
        ? DATA_REASON.AUTOPAY_BANNER.EXPAND
        : DATA_REASON.AUTOPAY_BANNER.COLLAPSE;
    const handleToggle = (event) => {
        if (('key' in event &&
            ['Enter', ' '].includes(event.key)) ||
            ('type' in event && event.type === 'click')) {
            toggleIsExpanded();
        }
    };
    if (isExpandable) {
        return (_jsx(CollapseButton, Object.assign({ "aria-controls": "autopay-banner", "aria-expanded": isExpanded, "data-analytics": DATA_ANALYTICS.CLICK_TRACKING_EVENT, "data-cy": "autopay-banner-expand", "data-object": "button", "data-reason": dataReason, "data-type": DATA_TYPE.MAKE_A_PAYMENT, role: "button", tabIndex: 0, onClick: handleToggle, onKeyDown: handleToggle }, { children: children })));
    }
    return _jsx(_Fragment, { children: children });
};
export default AutopayBannerCollapseButton;
